
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { ObtenerTipoJuicio } from '../connections/catalogos/TipoJuicioConnection';
import { ObtenerObjetoExhorto } from '../connections/catalogos/ObjetoExhortoConnection';
import { ObtenerClaseExhorto } from '../connections/catalogos/ClaseExhortoConnection';
import { ObtenerAutoridadExhortoRecibido } from '../connections/catalogos/AutoridadExhortoRecibidoConnection';
import { ObtenerEtapa } from '../connections/catalogos/EtapaConnection';
import { ObtenerSubEtapa } from '../connections/catalogos/SubEtapaConnection';
import { BuscarSecretariosAdmisibilidad, ObtenerUsuarioJuez } from '../connections/admin/UsuarioConnection';
import { EditarExhortoRecibido } from '../connections/tribunal/ExpedienteVirtualConnection';

import { ExhortoRecibidoProps } from '../interfaces/tribunal/ExpedienteVirtualInterface';
import { TipoJuicioProps } from '../interfaces/catalogos/TipoJuicioInterface';
import { ObjetoExhortoProps } from '../interfaces/catalogos/ObjetoExhortoInterface';
import { ClaseExhortoProps } from '../interfaces/catalogos/ClaseExhortoInterface';
import { AutoridadExhortoRecibidoProps } from '../interfaces/catalogos/AutoridadExhortoRecibidoInterface';
import { EtapaProps } from '../interfaces/catalogos/EtapaInterface';
import { SubEtapaProps } from '../interfaces/catalogos/SubEtapaInterface';
import { UsuarioJuezProps, UsuarioSecretarioProps } from '../interfaces/admin/UsuarioInterface';

interface Props {
    openDialog:         boolean;
    handleCloseDialog:  () => void;
    exhorto:            ExhortoRecibidoProps;
    onGuardar:          ( exhorto: ExhortoRecibidoProps ) => void;
}

export const DialogEditarExhortoRecibido = ( { openDialog, handleCloseDialog, exhorto, onGuardar }: Props ) => {

    const dispatch = useDispatch();

    const [guardando, setGuardando] = useState( false );

    const [cuantiaEditada, setCuantiaEditada] = useState( '' );

    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>( [] );
    const [objetoExhortoArray, setObjetoExhortoArray] = useState<ObjetoExhortoProps[]>( [] );
    const [claseExhortoArray, setClaseExhortoArray] = useState<ClaseExhortoProps[]>( [] );
    const [autoridadExhortoRecibidoArray, setAutoridadExhortoRecibidoArray] = useState<AutoridadExhortoRecibidoProps[]>( [] );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );
    const [juezArray, setJuezArray] = useState<UsuarioJuezProps[]>( [] );
    const [secretariosArray, setSecretariosArray] = useState<UsuarioSecretarioProps[]>( [] );

    const [tipoJuicioEditado, setTipoJuicioEditado] = useState( 0 );
    const [objetoExhortoEditado, setObjetoExhortoEditado] = useState( 0 );
    const [claseExhortoEditada, setClaseExhortoEditada] = useState( 0 );
    const [autoridadExhortoRecibidoEditada, setAutoridadExhortoRecibidoEditada] = useState( 0 );
    const [etapaEditada, setEtapaEditada] = useState( 0 );
    const [subEtapaEditada, setSubEtapaEditada] = useState( 0 );
    const [subEtapaEditadaTemp, setSubEtapaEditadaTemp] = useState( 0 );
    const [juezEditado, setJuezEditado] = useState( 0 );
    const [secretarioEditado, setSecretarioEditado] = useState( 0 );

    const handleGuardar = async () => {

        setGuardando( true );

        const tipoJuicioDescripcion = tipoJuicioArray.find( ({ idTipoJuicio }) => idTipoJuicio === tipoJuicioEditado )?.descripcion ?? '';
        const objetoExhortoDescripcion = objetoExhortoArray.find( ({ idObjetoExhorto }) => idObjetoExhorto === objetoExhortoEditado )?.descripcion ?? '';
        const claseExhortoDescripcion = claseExhortoArray.find( ({ idClaseExhorto }) => idClaseExhorto === claseExhortoEditada )?.descripcion ?? '';
        const autoridadExhortoRecibidoDescripcion = autoridadExhortoRecibidoArray.find( ({ idAutoridadExhortoRecibido }) => idAutoridadExhortoRecibido === autoridadExhortoRecibidoEditada )?.descripcion ?? '';
        const etapaDescripcion = etapaArray.find( ({ idEtapa }) => idEtapa === etapaEditada )?.descripcion ?? '';
        const subEtapaDescripcion = subEtapaArray.find( ({ idSubEtapa }) => idSubEtapa === subEtapaEditada )?.descripcion ?? '';
        const juezDescripcion = juezArray.find( ({ idUsuario }) => idUsuario === juezEditado )?.nombreCompleto ?? '';
        const secretarioDescripcion = secretariosArray.find( ({ id }) => id === secretarioEditado )?.nombreCompleto ?? '';

        await EditarExhortoRecibido({
            idExhortoRecibido:          exhorto.idExhortoRecibido,
            idTipoJuicio:               tipoJuicioEditado,
            idObjetoExhorto:            objetoExhortoEditado,
            idClaseExhorto:             claseExhortoEditada,
            idAutoridadExhortoRecibido: autoridadExhortoRecibidoEditada,
            idJuez:                     juezEditado,
            idSecretario:               secretarioEditado,
            cuantia:                    cuantiaEditada,
            idEtapa:                    etapaEditada,
            idSubEtapa:                 subEtapaEditada,
        }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    onGuardar({
                        ...exhorto,
                        cuantia:            cuantiaEditada,
                        idTipoJuicio:       tipoJuicioEditado,
                        tipoJuicio:         tipoJuicioDescripcion,
                        idObjetoExhorto:    objetoExhortoEditado,
                        objetoExhorto:      objetoExhortoDescripcion,
                        idClaseExhorto:     claseExhortoEditada,
                        claseExhorto:       claseExhortoDescripcion,
                        idAutoridadExhortoRecibido: autoridadExhortoRecibidoEditada,
                        autoridadExhortoRecibido:   autoridadExhortoRecibidoDescripcion,
                        idEtapa:            etapaEditada,
                        etapa:              etapaDescripcion,
                        idSubEtapa:         subEtapaEditada,
                        subEtapa:           subEtapaDescripcion,
                        idJuez:             juezEditado,
                        juez:               juezDescripcion,
                        idSecretario:       secretarioEditado,
                        secretario:         secretarioDescripcion,
                    });

                    dispatch( openSnackbar({ message, variant: 'success' }) );
                    handleCloseDialog();

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

                setGuardando( false );

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener(){
            await ObtenerTipoJuicio().then( resp => {
                setTipoJuicioArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerObjetoExhorto().then( resp => {
                setObjetoExhortoArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerClaseExhorto().then( resp => {
                setClaseExhortoArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerAutoridadExhortoRecibido().then( resp => {
                setAutoridadExhortoRecibidoArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerEtapa().then( resp => {
                setEtapaArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerUsuarioJuez().then( resp => {
                setJuezArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await BuscarSecretariosAdmisibilidad().then( resp => {
                setSecretariosArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){

            setSubEtapaEditada( 0 );
            setSubEtapaArray( [] );

            await ObtenerSubEtapa( etapaEditada ).then( resp => {
                setSubEtapaArray( resp );
            });

        }

        if( etapaEditada !== 0 ){
            Obtener();
        }

    }, [ etapaEditada ]);
    
    useEffect(() => {

        if( openDialog ){

            setCuantiaEditada( exhorto.cuantia );
            setTipoJuicioEditado( exhorto.idTipoJuicio );
            setObjetoExhortoEditado( exhorto.idObjetoExhorto );
            setClaseExhortoEditada( exhorto.idClaseExhorto );
            setAutoridadExhortoRecibidoEditada( exhorto.idAutoridadExhortoRecibido );
            setEtapaEditada( exhorto.idEtapa );
            setSubEtapaEditadaTemp( exhorto.idSubEtapa );
            setJuezEditado( exhorto.idJuez );
            setSecretarioEditado( exhorto.idSecretario );

        }

    }, [ openDialog, exhorto ]);

    useEffect(() => {

        if( subEtapaEditadaTemp !== 0 && subEtapaArray.length !== 0 ){
            setSubEtapaEditada( subEtapaEditadaTemp );
        }

    }, [ subEtapaEditadaTemp, subEtapaArray.length ]);

    return (

        <Dialog
            fullWidth
            maxWidth='md'
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>Editar exhorto</DialogTitle>

            <DialogContent>

                <Grid container spacing={3} sx={{ mt: 1 }}>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            label='Cuantía'
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                            value={ cuantiaEditada }
                            onChange={ (e) => setCuantiaEditada( e.target.value ) }
                        />

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Tipo de juicio</InputLabel>

                            <Select
                                notched
                                label='Tipo de juicio'
                                value={ tipoJuicioEditado }
                                onChange={ (e) => setTipoJuicioEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    tipoJuicioArray.map( ({ idTipoJuicio, descripcion }) => (
                                        <MenuItem key={ idTipoJuicio } value={ idTipoJuicio }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Objeto del exhorto</InputLabel>

                            <Select
                                notched
                                label='Objeto del exhorto'
                                value={ objetoExhortoEditado }
                                onChange={ (e) => setObjetoExhortoEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    objetoExhortoArray.map( ({ idObjetoExhorto, descripcion }) => (
                                        <MenuItem key={ idObjetoExhorto } value={ idObjetoExhorto }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Clase de exhorto</InputLabel>

                            <Select
                                notched
                                label='Clase de exhorto'
                                value={ claseExhortoEditada }
                                onChange={ (e) => setClaseExhortoEditada( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    claseExhortoArray.map( ({ idClaseExhorto, descripcion }) => (
                                        <MenuItem key={ idClaseExhorto } value={ idClaseExhorto }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 12, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Autoridad del exhorto</InputLabel>

                            <Select
                                notched
                                label='Autoridad del exhorto'
                                value={ autoridadExhortoRecibidoEditada }
                                onChange={ (e) => setAutoridadExhortoRecibidoEditada( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    autoridadExhortoRecibidoArray.map( ({ idAutoridadExhortoRecibido, descripcion }) => (
                                        <MenuItem key={ idAutoridadExhortoRecibido } value={ idAutoridadExhortoRecibido }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Etapa</InputLabel>

                            <Select
                                notched
                                label='Etapa'
                                value={ etapaEditada }
                                onChange={ (e) => { setSubEtapaEditada( 0 ); setEtapaEditada( e.target.value as number ); } }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    etapaArray
                                    .filter( ({ idEtapa }) => idEtapa === 18 )
                                    .map( ({ idEtapa, descripcion }) => (
                                        <MenuItem key={ idEtapa } value={ idEtapa }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Subetapa</InputLabel>

                            <Select
                                notched
                                label='Subetapa'
                                value={ subEtapaEditada }
                                onChange={ (e) => setSubEtapaEditada( e.target.value as number ) }
                                disabled={ etapaEditada === 0 || subEtapaArray.length === 0 }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    subEtapaArray.map( ({ idSubEtapa, descripcion }) => (
                                        <MenuItem key={ idSubEtapa } value={ idSubEtapa }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>
                    
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Juez</InputLabel>

                            <Select
                                notched
                                label='Juez'
                                value={ juezEditado }
                                onChange={ (e) => setJuezEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    juezArray.map( ({ idUsuario, nombreCompleto }) => (
                                        <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>  
            
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a) de trámite</InputLabel>

                            <Select
                                notched
                                label='Secretario(a) de trámite'
                                value={ secretarioEditado }
                                onChange={ (e) => setSecretarioEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>                    

                </Grid>

            </DialogContent>

            <DialogActions>
                <Button color='secondary' onClick={ handleCloseDialog } disabled={ guardando }>Cancelar</Button>
                <Button variant='contained' loading={ guardando } onClick={ handleGuardar }>Guardar</Button>
            </DialogActions>

        </Dialog>

    );

}
